<div
  class="colorful-text"
  [ngClass]="{
    bold: bold,
  }"
  [class]="class"
>
  <ng-content />
</div>
